import { CustomError } from 'store/api';

const isCustomError = (error: unknown): error is CustomError =>
  typeof error === 'object' && error !== null && 'data' in error;

export default isCustomError;
